<template>
    <div>
        <transition name="slide-fade">
            <div class="menu-wrap" v-if="active" :style="menuStyle">
                <div class="menu" v-click-outside="onClickOutside">
                    <button class="menu-close" :class="{ hidden: isSearchActive }" @click="closeHandler(true)">
                        <CloseIcon class="menu-close__icon" data-voicetext="закрыть боковое меню" />
                    </button>

                    <div v-if="false" class="search-box" :class="{ active: isSearchActive }">
                        <button
                            class="search-box__button"
                            :class="{ active: isSearchActive }"
                            @click="searchHandler(true)"
                        >
                            <SearchIcon class="search-box__icon" />
                        </button>
                    </div>

                    <transition v-if="false" name="mobile-search-transition">
                        <HeaderSearch
                            v-if="isSearchShown"
                            @close="searchHandler(false)"
                            @navigate="closeHandler(true)"
                        />
                    </transition>

                    <div class="menu-body">
                        <div v-for="(listItems, index) in listGroups" :key="index" class="menu-list-group">
                            <div class="menu-list">
                                <div v-for="(item, index) in listItems" :key="index" class="menu-list__item">
                                    <a v-if="item.link" :href="item.link" :target="item.blank ? '_blank' : ''">
                                        {{ item.title }}
                                    </a>
                                    <router-link v-else :to="item.to">
                                        {{ item.title }}
                                    </router-link>
                                </div>
                            </div>
                        </div>
                        <div class="menu-list-group">
                            <div class="menu-list">
                                <div class="menu-list__item">
                                    <router-link :to="{ name: 'contacts' }"> Контакты </router-link>
                                </div>
                                <div
                                    class="menu-list__item menu-list__item--semibold"
                                    v-for="(phone, index) in formattedPhoneNumbers"
                                    :key="index"
                                >
                                    <a class="menu-list__item-contacts" :href="phone.href">{{ phone.display }}</a>
                                </div>
                                <div class="menu-list__item menu-list__item--semibold" v-if="card.mail">
                                    <a class="menu-list__item-contacts" :href="`mailto:${card.mail}`">{{
                                        card.mail
                                    }}</a>
                                </div>
                                <div class="menu-list__item">
                                    <SocialLinks
                                        class="social-links social-links--sidebar"
                                        vk
                                        max
                                        ok
                                        tg
                                        youtube
                                        rutube
                                        yappy
                                        dzen
                                        tenchat
                                        size="small"
                                    />
                                </div>
                            </div>
                            <div class="menu-list w-100">
                                <button class="btn-white-outline btn-help" @click="showSupportForm">
                                    Помощь
                                    <IconMessage />
                                </button>
                            </div>
                        </div>
                        <div class="menu-list-group">
                            <div class="menu-list">
                                <div class="menu-list__item menu-list__item--semibold menu-list__item--underlined">
                                    <a href="javascript:;" @click="$accessibility.toggle()">
                                        Версия для слабовидящих
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div class="menu-list-group">
                            <div class="menu-list">
                                <div v-if="isAuthorized" class="menu-list__item menu-list__item--thin">
                                    <a @click="logoutHandle"> Выйти <LogoutIcon class="logout-icon" /> </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
        <FeedBackPopup v-model="isSupportFormShown" :defaultEmail="defaultEmail" :defaultName="defaultName" />
    </div>
</template>

<script>
import CloseIcon from '@/assets/images/icons/close.svg?inline';
import SearchIcon from '@/assets/images/icons/search.svg?inline';
import LogoutIcon from '@/assets/images/icons/logout.svg?inline';
import { mapActions, mapGetters } from 'vuex';
import HeaderSearch from './MobileHeaderSearch';
import { securityService } from '@/tools/sequrity_service';
import appBaseUrl from '@/tools/appBaseUrl';
import SocialLinks from '@/components/UI/SocialLinks';
import FeedBackPopup from '@/components/contacts/FeedBackPopup';
import IconMessage from '@/components/UI/icons/IconMessage.vue';

const getters = ['isMobile', 'vh', 'contacts', 'userProfileInfo', 'height'];

const userGetters = ['isAuthorized', 'userHasRoles', 'userHasRoleAttribute'];

const actions = ['setHtmlScroll', 'loadRoleAttributes', 'getContacts'];

export default {
    components: {
        FeedBackPopup,
        SocialLinks,
        CloseIcon,
        SearchIcon,
        HeaderSearch,
        LogoutIcon,
        IconMessage,
    },
    data: () => ({
        isSearchActive: false,
        isSearchShown: false,
        closeOnClickOutside: false,
        rsvDomain: window.rsvDomain,
        card: {},
        defaultEmail: '',
        defaultName: '',
        isSupportFormShown: false,
    }),
    props: {
        active: Boolean,
    },
    computed: {
        ...mapGetters(getters),
        ...mapGetters('auth', userGetters),
        menuStyle() {
            return {
                height: this.height + 'px',
            };
        },
        formattedPhoneNumbers() {
            if (!this.card || !this.card.phone) {
                return [];
            }
            const phoneString = this.card.phone;
            return phoneString.split(', ').map((phone) => {
                return {
                    href: `tel:${phone.replace(/[^\d+]/g, '')}`,
                    display: phone,
                };
            });
        },
        listGroups() {
            return [
                [
                    {
                        title: 'Панель администратора',
                        link: `https://administrator.${this.rsvDomain}/`,
                        roles: [
                            'ROLE_TASKS_DD',
                            'ROLE_CASHBACK_ADMIN',
                            'ROLE_PROJECT_ADMIN_READ_ONLY',
                            'ROLE_PRESS_ADMIN',
                            'ROLE_PROJECT_ADMIN',
                            'ROLE_CLUBS_ADMIN',
                            'ROLE_LEADERS_ADMIN',
                            'ROLE_ADMIN',
                            'ROLE_CURATOR',
                            'ROLE_EDUCATION_ADMIN',
                            'ROLE_EDUCATION_ADMIN_LIMIT',
                            'ROLE_EDUCATION_ADMIN_READ_ONLY',
                            'ROLE_USER_ADMIN_READ_ONLY',
                            'ROLE_PROJECT_HEAD',
                            'ROLE_PROJECT_MANAGER',
                            'ROLE_LISTENER',
                            'ROLE_LISTENER_NO_CONTACTS',
                            'ROLE_VACANCY_ADMIN',
                            'ROLE_TESTING_ADMIN_LIMIT',
                            'ROLE_REVIEW_ADMIN',
                        ],
                    },
                    {
                        title: 'Поиск пользователей',
                        link: `${appBaseUrl}account/user-search`,
                        roles: ['ROLE_ADMIN', 'ROLE_USER_ADMIN_READ_ONLY', 'ROLE_USER_ADMIN_READ_ONLY_NO_CONTACTS'],
                    },
                    {
                        title: 'Кабинет эксперта',
                        link: `${appBaseUrl}expert-panel`,
                        roles: ['ROLE_EXPERT'],
                    },
                    {
                        title: 'Кабинет Руководителя',
                        link: `${appBaseUrl}head-office`,
                        roles: ['ROLE_HEAD_OFFICE_MANAGER'],
                    },
                    {
                        title: 'Проекты',
                        link: `https://${window.rsvDomain}/competitions`,
                    },
                    {
                        title: 'Бонусы «Другое Дело»',
                        link: `https://${window.rsvDomain}/drugoedelo/`,
                    },
                    {
                        title: 'Стажировки',
                        link: `https://${window.rsvDomain}/internships/`,
                    },
                    {
                        title: 'Онлайн-курсы',
                        link: `https://${window.rsvDomain}/education`,
                    },
                    {
                        title: 'Компетенции и ценности',
                        to: { name: 'competences' },
                    },
                    {
                        title: 'Тесты',
                        to: { name: 'testingPreList' },
                    },
                    // {
                    //     title: 'Наставничество',
                    //     to: { name: 'mentoring' },
                    // },
                    {
                        title: 'Мастерская управления «Сенеж»',
                        link: 'https://senezh.rsv.ru/',
                    },
                ],
                [
                    {
                        title: 'Новости',
                        to: { name: 'news' },
                    },
                    {
                        title: 'Истории успеха',
                        to: { name: 'success' },
                    },
                    {
                        title: 'Блог',
                        link: 'https://rsv.ru/blog',
                    },
                    // {
                    //     title: 'Подкасты',
                    //     link: 'https://rsv.ru/education/courses/1/1082/',
                    // },
                    {
                        title: 'Фотогалерея',
                        to: { name: 'gallery' },
                    },
                ],
                [
                    {
                        title: 'О нас',
                        to: { name: 'about-us' },
                    },
                    {
                        title: 'Карьера у нас',
                        link: `https://career.rsv.ru/`,
                    },
                    {
                        title: 'Наблюдательный совет',
                        to: { name: 'supervisory-board' },
                    },
                    {
                        title: 'Документы',
                        link: `https://${window.rsvDomain}/documents`,
                    },

                    /*{
                        title: 'Сведения об образовательной организации',
                        to: {
                            name: 'education-info',
                            params: { component: 'navigation' },
                        },
                    },
                    */
                ],
            ].reduce((a, e) => {
                const list = e.filter(
                    (v) =>
                        !(
                            (v.roles && !this.userHasRoles(v.roles)) ||
                            (v.roleAttribute && !this.userHasRoleAttribute(v.roleAttribute))
                        )
                );
                if (list) {
                    a.push(list);
                }
                return a;
            }, []);
        },
    },
    async mounted() {
        await this.getContacts();
        this.card = this.contacts.card;
    },
    methods: {
        ...mapActions(actions),
        closeHandler(force) {
            (force || !this.isMobile) && this.$emit('change', false);
        },
        searchHandler(active) {
            this.isSearchActive = active;
        },
        logoutHandle() {
            securityService.signOut();
        },
        onClickOutside() {
            this.closeOnClickOutside && this.closeHandler(false);
        },
        showSupportForm() {
            // HINT: возможно пригодится
            // this.defaultEmail = this.userProfileInfo.regEmail ? this.userProfileInfo.regEmail : '';
            // this.defaultName = this.userProfileInfo.name ? this.userProfileInfo.name : '';
            // this.isSupportFormShown = true;
            // в рамках текущей вкладки браузера
            window.location.href = `https://${window.rsvDomain}/faq/`;
        },
    },
    watch: {
        isSearchActive(v) {
            if (v) {
                setTimeout(() => {
                    this.isSearchShown = true;
                }, 300);
            } else {
                this.isSearchShown = false;
            }
        },
        active(v) {
            this.setHtmlScroll(!v);
            setTimeout(() => {
                this.closeOnClickOutside = v;
            }, 100);
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/rem';
@import '~@/styles/variables';

$blue: var(--color-blue-85);
$lightBlue: var(--color-blue-50);

.menu-wrap {
    padding: 0;
    background: $blue;
    position: absolute;
    top: 0;
    left: 0;
    @include on-desktop {
        padding: rem(4) rem(9) rem(8) 0;
        box-shadow: 4px 0 8px rgba(0, 0, 0, 0.25);
        border-radius: 0 rem(16) rem(16) 0;
    }
}
.menu {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    background: $blue;
    height: 100%;
    overflow: auto;
    width: 100%;
    padding-bottom: mrem(30);

    font-family: GolosText, sans-serif;
    font-weight: 500;
    font-size: mrem(18);
    line-height: mrem(24);
    scrollbar-width: thin;
    scrollbar-color: rgba(255, 255, 255, 0.4) $blue;

    @include on-desktop {
        width: rem(274);
        font-size: rem(18);
        line-height: rem(24);
        padding-bottom: rem(30);
        height: calc(var(--vh, 1vh) * 100);
        max-height: 98vh;
    }

    &::-webkit-scrollbar {
        width: mrem(9);
        @include on-desktop {
            width: rem(9);
            right: rem(-9);
        }
    }
    &::-webkit-scrollbar-track {
        background: $blue;
        @include on-desktop {
            left: rem(-10);
        }
    }
    &::-webkit-scrollbar-thumb {
        background: rgba(255, 255, 255, 0.4);
        border-radius: mrem(16);
        @include on-desktop {
            border-radius: rem(16);
        }
    }
    .menu-close {
        display: flex;
        justify-content: flex-start;
        background: $blue;
        padding: mrem(30);
        cursor: pointer;
        outline: none;
        border: none;
        color: rgba(255, 255, 255, 0.8);
        transition: padding-top 0.3s linear, padding-bottom 0.3s linear;

        @include on-desktop {
            padding: rem(30);
            background: $blue;
        }

        &__icon {
            height: mrem(22);
            width: mrem(22);

            @include on-desktop {
                height: rem(22);
                width: rem(22);
            }
        }

        &.hidden > * {
            transform: scale(0);
            opacity: 0;
            transition: inherit;
        }

        &.hidden {
            transform: scale(0);
            height: 0;
            min-height: 0;
            padding: 0;
        }
    }

    .menu-body {
        padding: 0 mrem(36);
        display: flex;
        flex-direction: column;
        flex: 1;

        @include on-desktop {
            padding: 0 rem(30);
            padding-right: rem(20);
        }
    }

    .search-box {
        padding: 0 mrem(36);
        transition: all 0.3s;
        margin-bottom: mrem(24);
        @include on-desktop {
            padding: 0 rem(30);
            margin-bottom: rem(24);
        }
        &__button {
            background: $lightBlue;
            border-radius: mrem(10);
            height: mrem(40);
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            padding: 0 mrem(11);
            outline: none;
            border: none;
            color: inherit;
            margin: 0;
            transition: 0.3s;

            @include on-desktop {
                height: rem(40);
                padding: 0 rem(8);
                border-radius: rem(10);
            }
        }
        &__icon {
            width: mrem(24);
            height: mrem(24);
            @include on-desktop {
                width: rem(24);
                height: rem(24);
            }
        }
        &.active {
            padding: 0;
            .search-box__button {
                height: mrem(56);
                @include on-desktop {
                    height: rem(56);
                }
            }
        }
    }
    .menu-list {
        color: inherit;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        &-group {
            margin-bottom: mrem(40);
            @include on-desktop {
                margin-bottom: rem(40);
            }
            &:last-of-type {
                margin-bottom: 0;
            }
        }

        &__item-contacts {
            &:hover {
                color: var(--color-light-text);
                font-weight: 700;
            }
        }

        &__item {
            cursor: pointer;
            margin-top: mrem(14);
            color: #dae0ee;

            @include on-desktop {
                margin-top: rem(14);
            }

            &:first-child {
                margin-top: 0;
            }

            * {
                display: flex;
                align-items: center;
                color: inherit;
            }

            &:hover {
                color: var(--color-light-text);
                font-weight: 700;
            }

            &--thin {
                color: rgba(255, 255, 255, 0.6);
                font-weight: normal;
                &:hover {
                    font-weight: normal;
                }
            }

            &--semibold {
                font-weight: 600;
                line-height: 1;
                cursor: auto;
                &:hover {
                    font-weight: 600;
                    line-height: 1;
                    color: #dae0ee;
                }
            }

            &--underlined {
                font-weight: 700;
                line-height: mrem(24);
                @include on-desktop {
                    line-height: rem(24);
                }
                &:hover {
                    font-weight: 700;
                    text-decoration: underline;
                    line-height: mrem(24);
                    @include on-desktop {
                        line-height: rem(24);
                    }
                }
            }

            .logout-icon {
                margin-left: mrem(8);
                width: mrem(21);
                height: mrem(21);

                @include on-desktop {
                    margin-left: rem(8);
                    width: rem(21);
                    height: rem(21);
                }
            }
        }
    }
}
.btn-white-outline {
    border: urem(2) solid #dae0ee;
    border-radius: 10px;
    background: transparent;
    padding: mrem(13);
    font-size: mrem(12);
    font-weight: 700;
    text-transform: uppercase;
    color: #dae0ee;
    display: block;
    width: 100%;
    cursor: pointer;

    @include on-desktop {
        font-size: rem(12);
        padding: rem(13);
    }
}
.btn-help {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;
    gap: urem(10);
    color: white;
    text-transform: uppercase;
    padding: urem(10) 0;
    font-family: $font-montserrat;

    :deep(svg) {
        width: urem(24);
        height: urem(24);
    }
}
.w-100 {
    width: 100%;
}
// }

.mobile-search-transition-enter-active,
.mobile-search-transition-leave-active {
    transition: opacity 0.3s;
}
.mobile-search-transition-enter,
.mobile-search-transition-leave-to {
    opacity: 0;
}

@include on-desktop {
    .slide-fade-enter-active,
    .slide-fade-leave-active {
        transition: left 0.5s;
    }
    .slide-fade-enter,
    .slide-fade-leave-to {
        left: rem(-382);
    }
}
</style>
